export const FIREBASE_AUTH_INACTIVE_MESSAGE = "Firebase Authentication is not active.";
export const AUTH_SESSION_NOT_FOUND_MESSAGE = "Authenticated Firebase session not found.";
export const AUTH_NOT_SIGNED_IN_MESSAGE = "Not signed in (expected for connection-only verification)";
export const FIRESTORE_CONNECTION_VERIFIED_MESSAGE = "Connection verified.";
export const WRITE_TESTS_SKIPPED_MESSAGE = "Write tests skipped because no authenticated Firebase user is available.";
export const SECURITY_RULES_DENIED_MESSAGE = "Security Rules denied access.";
export const SECURITY_RULES_RESPONDED_MESSAGE = "Security rules responded — Firestore endpoint reachable";
export const INVALID_FIRESTORE_PATH_MESSAGE = "Invalid Firestore collection/document path.";
export const RUNTIME_MISMATCH_MESSAGE = "Runtime mismatch detected.";
export const AUTH_RUNTIME_MISMATCH_MESSAGE = "AUTH RUNTIME MISMATCH";

export const HEALTH_CHECK_MODE_AUTHENTICATED = "authenticated";
export const HEALTH_CHECK_MODE_CONNECTION_ONLY = "connection_only";
